<template>
    <CToaster>
        <slot />
    </CToaster>
</template>

<script setup>
import { CToaster } from '@coreui/vue-pro'
</script>

<style scoped>

</style>
